export const PRINT_OPTIONS = [
  { value: 'packing', title: 'Задание для отгрузки' }
]
